export const en = {
    'less-then-min-limit': 'Maximum expenditure must be at least {minLimit}%',
    'limit-must-be-set': 'Please set the maximum expenditure: enter an integer from {minLimit} to {maxLimit}',
    'more-then-max-limit': 'Maximum expenditure must not exceed {maxLimit}%',
    'unavailable-goal': 'The selected goal is not available'
};
